module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-4-c6f26035682ee5ac6cd18bed12c685c0.jpg";